import { useParams, usePathname, useRouter } from 'next/navigation'
import { useMemo } from 'react'

import { useGetCatalogBrandsFilterQuery } from '@/entities/catalog-brands'

import { appliedFiltersAdapter } from '../lib/applied-filters-adapter'
import { getFilterJsonFromAppliedFilters } from '../lib/get-filter-json-from-applied-filters'

type useAppliedFiltersProps = {
	onChange?: (value: string) => any
}

export const useAppliedFilters = (props: useAppliedFiltersProps) => {
	const { onChange } = props || {}

	const router = useRouter()
	const pathname = usePathname()
	const params = useParams()

	const resolvedUrl = pathname

	// Получаем код бренда и категории из URL
	// Для маршрута /brand/[brand]/[...category] параметры будут в params.brand и params.category
	const brandCode = (params.brand as string) || ''
	const categoryParams = (params.category as string[]) || []
	const categoryCode = Array.isArray(categoryParams) && categoryParams.length > 0 ? categoryParams[0] : ''

	const { data: filterData, isFetching } = useGetCatalogBrandsFilterQuery(
		{
			brandCode,
			categoryCode,
			resolvedUrl
		},
		{ skip: !brandCode || !categoryCode }
	)

	const appliedFilters = useMemo(() => {
		if (!filterData?.PROPERTIES) return []
		return appliedFiltersAdapter(filterData?.PROPERTIES)
	}, [filterData?.PROPERTIES])

	const deleteItem = async (id: string) => {
		try {
			const newAppliedList = appliedFilters.filter(item => item.id !== id)
			const filterParseData = getFilterJsonFromAppliedFilters(newAppliedList)

			onChange?.(JSON.stringify(filterParseData))
		} catch (error) {
			console.error('DEBUG: Error in deleteItem:', error)
		}
	}

	const clearAll = async () => {
		onChange?.(JSON.stringify({}))

		// Если onChange не предоставлен, перенаправляем на базовый URL
		if (!onChange && brandCode && categoryCode) {
			await router.push(`/brand/${brandCode}/${categoryCode}/`)
		}
	}

	return {
		items: appliedFilters,
		deleteItem,
		clearAll,
		isLoading: isFetching
	}
}
